export type ApiPlatform = 'web' | 'pwa' | 'tma' | 'native-ios' | 'native-android'

let apiPlatform: ApiPlatform | null = null

export function setApiPlatform(platform: ApiPlatform): void {
  apiPlatform = platform
}

export function getApiPlatform(): ApiPlatform | null {
  return apiPlatform
}
